import {
  Cartesian3,
  Color,
  HeadingPitchRoll,
  Entity,
  Label,
  LabelStyle,
  PolylineOutlineMaterialProperty,
  TimeIntervalCollection,
  JulianDate,
  TimeInterval,
} from "cesium";


const palette =
  [
    [0, '#FF00B4'], [0.03125, '#FF00B4'], [0.0625, '#FA05CA'], [0.09375, '#F700FF'],
    [0.125, '#F700FF'], [0.15625, '#BF00FF'], [0.1875, '#DB00FF'], [0.21875, '#A105F7'],
    [0.25, '#6B00FF'], [0.28125, '#6B00FF'], [0.3125, '#4F00FF'], [0.34375, '#3403FB'],
    [0.375, '#1800FF'], [0.40625, '#0004FF'], [0.4375, '#0020FF'], [0.46875, '#003CFF'],
    [0.5, '#0058FF'], [0.53125, '#0074FF'], [0.5625, '#0090FF'], [0.59375, '#00C7FF'],
    [0.625, '#00C7FF'], [0.65625, '#00E3FF'], [0.6875, '#00E3FF'], [0.71875, '#FFDB00'],
    [0.75, '#FFB700'], [0.78125, '#FF9300'], [0.8125, '#F37200'], [0.84375, '#FF4B00'],
    [0.875, '#FF4B00'], [0.90625, '#F92B00'], [0.9375, '#FF0400'], [0.96875, '#FF2700'],
    [1.0, '#FF0044']
  ];

let newPallete = [];
let vSpeed_Min = 100000;
let vSpeed_Max = -100000;
let Inc3D = 100;

export function deleteEntities() {
  if (Entities.length > 0) {
    for (let z = 0; z < Entities.length; z++) {
      if (Entities[z].length > 0) {
        viewer.entities.removeAll();
      }
    }
  }
}

export function setCamera2(longitude, latitude, height, duration) {

  /*
  viewer.scene.camera.setView
  (
      {
            //destination: new Cesium.Cartesian3(3826465.9884728403,-254831.02751468265,5081387.671561018),
          //destination: new Cesium.Cartesian3.fromDegrees(longitude,46.9,height),
          destination: new Cesium.Cartesian3.fromDegrees(longitude,latitude,height),
          //orientation: new Cesium.HeadingPitchRoll(3.3889450556243754,-0.5276382514771969,6.282272566663295),
          orientation: new Cesium.HeadingPitchRoll(3.3889450556243754,-0.5276382514771969,6.282272566663295),
          endTransform: Cesium.Matrix4.IDENTITY,
      }
  );
  */

  var heading = 3.3889450556243754;
  var pitch = -0.5276382514771969;
  var roll = 6.282272566663295;
  heading = 0;
  pitch = -0.25;
  roll = 0;
  heading = 0;
  pitch = -0.15;
  roll = 0;

  viewer.scene.camera.flyTo
    (
      {
        destination: new Cartesian3.fromDegrees(longitude, latitude, height),
        orientation: new HeadingPitchRoll(heading, pitch, roll),
        duration: duration,
      }
    );
}

function getPilotName(fileIndex) {
  let pilotName = ArrNames[fileIndex]; // + ' (Kein Pilot identifiziert)';

  if (iGcFix[fileIndex].headers.find(headers => headers.name === 'Pilot')) {
    if (iGcFix[fileIndex].headers.find(headers => headers.name === 'Pilot').value) {
      pilotName = iGcFix[fileIndex].headers.find(headers => headers.name === 'Pilot').value;
    }
  }

  return pilotName
}

export function addEntities(fileList) {

  console.log("addEntities fileList.length=" + fileList.length)
  for (var fileIndex = 0; fileIndex < fileList.length; fileIndex++) {

    var TimeAnt = 0;
    var TimeNow = 0;
    var TimeDif = 0;

    var PosLonAnt = 0;
    var PosLatAnt = 0;
    var PosAltAnt = 0;

    var AltAnt = 0;
    var AltNow = 0;
    var AltDif = 0;
    var ColorSel = Color.YELLOW

    let pilotName = getPilotName(fileIndex)

    var pts = viewer.entities.add(new Entity());

    //adapt the palette to new igc data ---------------------------
    if (fileIndex == 0) {
      vSpeed_Min = -10.5;
      vSpeed_Max = 5;
      var vSpeed_Dif = (vSpeed_Max - vSpeed_Min);
      var vSpeed_Inc = vSpeed_Dif / palette.length;

      newPallete = [];
      var valor = vSpeed_Min;
      for (let z = 0; z < palette.length; z++) {
        newPallete[z] = [valor, palette[z][1]]
        valor = valor + vSpeed_Inc;
      }
    }
    // .------------------------------------------------------------

    Entities[fileIndex] = [];
    const lastRowIndex = fileList[fileIndex].length - 1

    for (let rowIndex = 0; rowIndex < fileList[fileIndex].length; rowIndex++) {

      // console.log(viewer.entities._entities.length)

      let fileItemPrev = fileList[fileIndex][rowIndex - 1];
      let fileItem = fileList[fileIndex][rowIndex];

      let PosLat = fileItem[0];
      let PosLon = fileItem[1];
      // let PosAlt = fileItem[2];
      let PosAlt = fileItem[2] + Inc3D;
      let PosTim = fileItem[3];
      let availability;

      if (PosLon) {
        TimeNow = PosTim;
        AltNow = PosAlt;
        //todo check AlNow
        let AlNow = PosTim;

        if (rowIndex > 0) {
          PosLonAnt = fileItemPrev[1];
          PosLatAnt = fileItemPrev[0];
          // PosAltAnt = fileItemPrev[2];
          PosAltAnt = fileItemPrev[2] + Inc3D;

          TimeAnt = fileItemPrev[3];
          TimeDif = TimeNow - TimeAnt;
          AltAnt = fileItemPrev[2];
          AltDif = AltNow - AltAnt;


          if (AltDif > 0) {
            ColorSel = Color.YELLOW;
          }
          else {
            ColorSel = Color.RED;
          }

          //todo check availability
          let startTime = TimeAnt;
          let endTime = PosTim
          // let start = JulianDate.fromIso8601(startTime);
          // let stop = JulianDate.fromIso8601(endTime);

          // let entityStartTime = start;
          // let entityStopTime = stop;

          availability = new TimeIntervalCollection([
            new TimeInterval({
              start: startTime,
              stop: endTime,
            }),
          ])

          // console.log(availability);
        }

        var CorGet = getColor(Vspeed[fileIndex][rowIndex]);
        ColorSel = Color.fromCssColorString(CorGet)



        if (rowIndex == 1) {
          Label.enableRightToLeftDetection = true;
          Entities[fileIndex][Entities[fileIndex].length] = viewer.entities.add
            (
              {
                position: Cartesian3.fromDegrees(PosLonAnt, PosLatAnt, (PosAltAnt + 10))
                , label:
                {
                  id: 'my_S_' + fileIndex
                  , name: 'teste Start name'
                  , text: '[' + (fileIndex + 1) + '] Start'
                  , description: 'teste Start description'
                  , font: "20px Helvetica"
                  , fillColor: Color.fromCssColorString('#40FF40')
                  , outlineColor: Color.WHITE
                  , outlineWidth: 2
                  , style: LabelStyle.FILL_AND_OUTLINE
                }
                , name: '   Start [' + (fileIndex + 1) + ']'
              }
            );
        } else if (rowIndex > 0) {

          Entities[fileIndex][Entities[fileIndex].length] = viewer.entities.add
            (
              {
                // availability: availability,
                polyline:
                {
                  parent: pts
                  , id: 'Line_' + (fileIndex + 1)
                  , name: 'teste Entity name'
                  , text: '[' + (fileIndex + 1) + '] Line'
                  , description: 'teste Entity description'

                  , positions: Cartesian3.fromDegreesArrayHeights
                    (
                      [
                        PosLonAnt, PosLatAnt, PosAltAnt,
                        PosLon, PosLat, PosAlt,
                      ]
                    )
                  , width: 2
                  , material: new PolylineOutlineMaterialProperty
                    (
                      {
                        color: ColorSel,
                        outlineWidth: 0,
                        outlineColor: Color.WHITE,
                      }
                    )
                  , clampToGround: false
                }
                , name: "   [" + (fileIndex + 1) + "] " + pilotName
                // Detail Information, Details
                , description: '' + PosAlt + " m <br>" + Vspeed[fileIndex][rowIndex][2] + " m/s<br>" + ('0' + PosTim.getHours()).slice(-2) + ":" + ('0' + PosTim.getMinutes()).slice(-2) + ":" + ('0' + PosTim.getSeconds()).slice(-2) + " (LT)"
                //<br>Latitude:"+PosLat+" <br>Longitude:"+PosLon+"

              }
            );

          if (rowIndex == lastRowIndex) {
            Label.enableRightToLeftDetection = true;
            Entities[fileIndex][Entities[fileIndex].length] = viewer.entities.add
              (
                {
                  position: Cartesian3.fromDegrees(PosLonAnt, PosLatAnt, (PosAltAnt + 10))
                  , label:
                  {
                    id: 'my_E_' + fileIndex
                    , text: 'Landung'
                    , name: 'teste Start name'
                    , description: 'teste End description'		// https://stackoverflow.com/questions/43181947/cesium-modify-infobox-contents
                    , font: "20px Helvetica"
                    , fillColor: Color.fromCssColorString('#A93535')
                    , outlineColor: Color.WHITE
                    , outlineWidth: 2
                    , style: LabelStyle.FILL_AND_OUTLINE
                  }
                  , name: "   Landung [" + (fileIndex + 1) + "]"
                }
              );
          }
        }
      }
      else {
        console.log('ERRO=[' + rowIndex + ' = ]' + fileItem);
      }

      if ((rowIndex == lastRowIndex) && (fileIndex == (fileList.length - 1))) {
      }
    }
  }
}


function getColor(vSpd) {
  var cor = '#000000';
  var speed = vSpd[2] * 1;

  var cor = '#000000';
  for (let c = 0; c < newPallete.length; c++) {

    var Val = newPallete[c][0] * 1;

    if (speed < (newPallete[0][0] * 1)) {
      cor = newPallete[c][1];
    }
    else {
      if (speed > (newPallete[(newPallete.length - 1)][0] * 1)) {
        cor = newPallete[(newPallete.length - 1)][1];
      }
      else {
        if (Val < speed) {
          cor = newPallete[c][1];
        }
      }
    }

    if (c == (newPallete.length - 1)) {
      return cor;
    }
  }

}